// src/components/pages/mypage/partials/PostsTab.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../style/MyPage.module.css';
import { useNavigate } from 'react-router-dom';

// PostList 렌더링 함수를 PostsTab 내부에 정의하거나 별도 파일로 분리할 수 있습니다.
const PostList = ({ posts, loading, emptyMessage, isMyPost, isSavedPost, handleDeletePost, handleUnsavePost, navigate, t }) => {
  if (loading) {
    return <p className={styles.loading}>{t('mypage.loading.generic')}</p>;
  }
  if (posts.length === 0) {
    return <p className={styles.emptyMessage}>{emptyMessage}</p>;
  }
  return (
    <div className={styles.postFeed}>
      {posts.map(post => (
        <div
          key={post.postId}
          className={styles.postItem}
          onClick={() => navigate(`/posts/${post.postId}`)}
        >
          <div className={styles.postContent}>
            <h3>{post.title}</h3>
            <p className={styles.postPreview}>{post.previewTitle}</p>
            <div className={styles.postMeta}>
              {isMyPost && <p>{t('mypage.post.likes')} {post.likes || 0}</p>}
              {!isMyPost && <p>{t('mypage.post.author')}{post.authorNickname || t('mypage.post.unknownAuthor')}</p>}
              <p>
                {t('mypage.post.createdAt')} {new Date(parseInt(post.createdAt)).toLocaleDateString()}
              </p>
              {isMyPost && (
                <div className={styles.actionButtons}>
                  <button
                    className={styles.actionBtn}
                    onClick={(e) => { e.stopPropagation(); navigate(`/posts/${post.postId}/edit`); }}
                  >✏️</button>
                  <button
                    className={styles.actionBtn}
                    onClick={(e) => { e.stopPropagation(); handleDeletePost(post.postId); }}
                  >🗑️</button>
                </div>
              )}
              {isSavedPost && (
                <div className={styles.actionButtons}>
                  <button
                    className={styles.actionBtn}
                    onClick={(e) => { e.stopPropagation(); handleUnsavePost(post.postId); }}
                  >🗑️
                    <span className={styles.tooltip}>{t('mypage.action.unsave')}</span>
                  </button>
                </div>
              )}
            </div>
          </div>
          {post.previewImageUrl && (
            <div className={styles.postImageWrapper}>
              <img src={post.previewImageUrl} alt={post.title} className={styles.postImage} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


export default function PostsTab({
  myPostsTab,
  setMyPostsTab,
  feedPosts,
  loadingFeedPosts,
  myPosts,
  loadingPosts,
  savedPosts,
  loadingSavedPosts,
  handleDeletePost,
  handleUnsavePost,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.tabContent}>
      <section className={styles.myPosts}>
        <div className={styles.subTabs}>
          <button
            className={`${styles.subTabButton} ${myPostsTab === 'feed' ? styles.active : ''}`}
            onClick={() => setMyPostsTab('feed')}
          >
            {t('mypage.followedPosts', { count: feedPosts.length })} ({feedPosts.length})
          </button>
          <button
            className={`${styles.subTabButton} ${myPostsTab === 'myPosts' ? styles.active : ''}`}
            onClick={() => setMyPostsTab('myPosts')}
          >
            {t('mypage.myPosts', { count: myPosts.length })} ({myPosts.length})
          </button>
          <button
            className={`${styles.subTabButton} ${myPostsTab === 'savedPosts' ? styles.active : ''}`}
            onClick={() => setMyPostsTab('savedPosts')}
          >
            {t('mypage.savedPosts', { count: savedPosts.length })} ({savedPosts.length})
          </button>
        </div>
        
        {myPostsTab === 'feed' && (
          <PostList
            posts={feedPosts}
            loading={loadingFeedPosts}
            emptyMessage={t('mypage.empty.feed')}
            navigate={navigate}
            t={t}
          />
        )}
        {myPostsTab === 'myPosts' && (
          <PostList
            posts={myPosts}
            loading={loadingPosts}
            emptyMessage={t('mypage.empty.myPosts')}
            isMyPost={true}
            handleDeletePost={handleDeletePost}
            navigate={navigate}
            t={t}
          />
        )}
        {myPostsTab === 'savedPosts' && (
          <PostList
            posts={savedPosts}
            loading={loadingSavedPosts}
            emptyMessage={t('mypage.empty.savedPosts')}
            isSavedPost={true}
            handleUnsavePost={handleUnsavePost}
            navigate={navigate}
            t={t}
          />
        )}

        {myPostsTab === 'myPosts' && (
          <>
            <br />
            <button onClick={() => navigate('/writepost')} className={styles.editBtn}>{t('mypage.writePost')}</button>
          </>
        )}
      </section>
    </div>
  );
}